module.exports = __webpack_public_path__ + "static/img/nodata_notification.1a1b38a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/notification/nodata_notification.png
// module id = 50Np
// module chunks = 134